import { useEffect, useMemo } from "react";
import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import { useAppBaseContext } from "providers";
import { useProjectMandator } from "stores/projectStore";
import { useAuthStore } from "stores/authStore";
import { filterProductListByMandator } from "./utils/filterProductListByMandator";

interface AppBaseContext {
  isSameProj: boolean;
  lang: string;
}

export const useAllProducts = () => {
  const currentUserTenant = useAuthStore.use.currentUser()?.tenant;

  const { isSameProj, lang } = useAppBaseContext() as AppBaseContext;
  const mandator = useProjectMandator();

  const allProducts = useProductsOverviewStore((state) => state.allProducts);
  const { getProductsData } = useProductsOverviewActions();

  useEffect(() => {
    getProductsData({ lang, currentUserTenant });
  }, [currentUserTenant, getProductsData, lang]);

  const list = useMemo(() => {
    if (!isSameProj || !mandator || !currentUserTenant) {
      return allProducts;
    }
    return filterProductListByMandator(
      allProducts,
      mandator,
      currentUserTenant,
    );
  }, [isSameProj, mandator, currentUserTenant, allProducts]);

  return list;
};
